import React from 'react';

import { MainWrapper, Section, Reveal, Button } from '../../shared';
import { useSettings } from '../../../context/SettingsContext';

import './WorkPage.scss';

export function WorkPage() {
  const { t } = useSettings();
  const w = t.work;
  const flagship = t.caseStudies[0];

  return (
    <MainWrapper currentPageName="Work" headerPageText={w.headerTitle} eyebrow={w.eyebrow} intro={w.intro}>
      {/* Flagship case study */}
      <Section ariaLabel={flagship.name}>
        <div className="flagship">
          <Reveal className="flagship__media">
            {flagship.image ? (
              <img src={flagship.image} alt={flagship.name} loading="lazy" />
            ) : (
              <div className="shot shot--placeholder" role="img" aria-label={`${flagship.name} ${w.screenshotSoon}`}>
                <span className="shot__tag">{flagship.name}</span>
                <span className="shot__note">{w.screenshotSoon}</span>
              </div>
            )}
          </Reveal>
          <Reveal delay={0.1} className="flagship__body">
            <span className="ds-eyebrow">
              {w.featuredPrefix}
              {flagship.tag}
            </span>
            <h2>{flagship.name}</h2>
            <p>{flagship.description}</p>
            <div className="flagship__story">
              <div>
                <h4>{w.story.needHead}</h4>
                <p>{w.story.needBody}</p>
              </div>
              <div>
                <h4>{w.story.howHead}</h4>
                <p>{w.story.howBody}</p>
              </div>
              <div>
                <h4>{w.story.sinceHead}</h4>
                <p>{w.story.sinceBody}</p>
              </div>
            </div>
            <div className="flagship__actions">
              <Button href={flagship.url}>{w.flagshipCta}</Button>
            </div>
          </Reveal>
        </div>
      </Section>

      {/* CTA */}
      <Section tint ariaLabel={w.cta.title}>
        <Reveal className="work-cta">
          <h2>{w.cta.title}</h2>
          <p>{w.cta.body}</p>
          <Button to="/contact">{w.cta.button}</Button>
        </Reveal>
      </Section>
    </MainWrapper>
  );
}

export default WorkPage;
